module.exports = __webpack_public_path__ + "img/check.16fa1f8c.svg";